// @core/api/endpoints/affiliate/update_affiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AffiliateResponse,
  UpdateAffiliateRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Update affiliate profile
 * Updates an existing affiliate with the provided data. Returns the updated resource.
 */
export async function UpdateAffiliate(
  affiliate_id: string,
  data: UpdateAffiliateRequest,
  options?: RequestOptions
): Promise<AffiliateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/affiliates/:affiliate_id`;
  requestPath = requestPath.replace(':affiliate_id', encodeURIComponent(affiliate_id));
  const requestOptions = options;
  return client.patch<AffiliateResponse>(requestPath, data, requestOptions);
}
